module.exports = __webpack_public_path__ + "img/firstVue.240f4473.gif";